module.exports = __webpack_public_path__ + "ce7d0ece06f68ecba009bc2d8472f874.pdf";